import { CALCULATORS } from '../hooks/useCalculators';

const PRIVATE_PAGE = {
  title: 'Account',
  description: 'PaisaWise account page.',
  noindex: true,
};

/** Exact pathname → meta. Dynamic routes (/post/:slug etc.) set meta in their page components. */
export const PAGE_META = {
  '/': {
    title: 'Wealth Management & Financial Planning',
    description:
      'Financial wisdom, retirement planning guides, and free calculators for your wealth management journey.',
  },
  '/tools': {
    title: 'Financial Planning Tools',
    description:
      'Essential calculators and tools for your wealth management journey — retirement, SIP, NPS, and more.',
  },
  '/about': {
    title: 'About Us',
    description:
      'Learn about PaisaWise — practical financial wisdom and tools for Indian investors and retirees.',
  },
  '/latest-insights': {
    title: 'Latest Insights',
    description: 'Browse the newest articles on personal finance, investing, and retirement planning.',
  },
  '/featured-insights': {
    title: 'Featured Insights',
    description: 'Hand-picked financial articles and guides from the PaisaWise editorial team.',
  },
  '/terms-and-conditions': {
    title: 'Terms and Conditions',
    description: 'Terms and conditions for using PaisaWise calculators, tools, and content.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    description: 'How PaisaWise collects, uses, and protects your personal information.',
  },
  '/search-results': {
    title: 'Search Results',
    description: 'Search results on PaisaWise.',
    noindex: true,
  },
  '/login': PRIVATE_PAGE,
  '/register': PRIVATE_PAGE,
  '/forgot-password': PRIVATE_PAGE,
  '/profile': PRIVATE_PAGE,
  '/chart/are-stocks-less-risky': {
    title: 'CAGR Across 100 Simulated Return Paths',
    description:
      'Interactive chart: return outcomes by holding period (years) across 100 simulated stock market paths.',
  },
  '/chart/simulated-nifty-returns': {
    title: '100 Simulated Return Paths for Nifty 50',
    description:
      'Interactive chart: annual return (%) for 100 simulated Nifty 50 paths by year.',
  },
};

// Calculator routes from shared registry
CALCULATORS.forEach((calc) => {
  PAGE_META[calc.route_path] = {
    title: calc.title,
    description: calc.description,
  };
});

export function getStaticPageMeta(pathname) {
  if (PAGE_META[pathname]) return PAGE_META[pathname];
  if (pathname.startsWith('/reset-password/')) return PRIVATE_PAGE;
  return null;
}
